import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {TimerangeModel} from './timerange.model';

@Injectable()
export class TimerangesApiService extends ReactiveServiceWithFilters implements Resolve<TimerangeModel[]> {
  private baseUrl = environment.backEndUrlPrefix + '/' + 'range_value';

  constructor(private http: HttpClient) {
    super();
  }

  getAll(paramOnId?: number): Observable<TimerangeModel[]> {
    const params = paramOnId ? {params: {paramOnId}} : {};
    return this.http.get<TimerangeModel[]>(this.buildUrl(this.baseUrl), params);
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TimerangeModel[]> | Promise<TimerangeModel[]> | TimerangeModel[] {
    // return this.snapshot.data ? this.snapshot.data : this.getAll();
    return this.getAll();
  }


}
